import FejezetTableService from 'app/admin/fejezet/service/FejezetTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'fejezetTable',
	text: 'Fejezet',
	textKey: 'chapters',
	service: FejezetTableService,
	icon: 'person',
	editFormState: item => `/fejezet/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'nev',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'nev',
			text: 'Név',
			textKey: 'nev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'sorszam',
			text: 'Sorszám',
			textKey: 'sorszam',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feladatCsoport',
			text: 'Feladatcsoport',
			textKey: 'feladatCsoport',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function FejezetTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('fejezetTable', reducer('fejezetTable'))(FejezetTable);
